export const AboutUs = () => {
  return (
    <div className="text-left relative isolate flex-1 overflow-hidden bg-white py-10 sm:py-32">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <div className="text-left mb-8 sm:mb-16">
          <p className="text-base/7 font-semibold text-primary-50">About</p>
          <h1 className="mt-2 text-4xl font-semibold tracking-tight text-pretty text-grey-100 sm:text-5xl">
            About Us
          </h1>
        </div>
        <div className="text-left space-y-6 text-base/7 text-grey-300">
          <p>
            MarketplaceAI is transforming healthcare staffing and credentialing through two
            integrated platforms: MedCredVault.com and HealthcareLX.com. We recognized that the
            healthcare workforce system was fragmented, expensive, and inefficient, with over 2,700
            staffing agencies controlling only a fraction of the temporary staffing market while
            credentialing remained a manual, error-prone process that delayed provider onboarding
            and created compliance risks. Our solution addresses these challenges head-on by
            combining secure credential management with AI-driven marketplace technology that
            connects healthcare providers directly with facilities seeking coverage.
          </p>
          <p>
            MedCredVault serves as a secure, centralized credential vault where healthcare providers
            of all types maintain complete control over their professional documentation, licenses,
            certifications, and career preferences. Unlike traditional credentialing systems that
            silo data within individual health systems, our platform gives providers true ownership
            of their credentials while using AI to verify documents, identify gaps, and alert users
            to upcoming expirations. HealthcareLX operates as a real-time, two-sided labor
            marketplace where providers can set their availability using an intuitive calendar
            interface while employers post opportunities ranging from single shifts to permanent
            positions and even Healthcare Labor as a Service arrangements for entire teams. Our
            advanced AI matching engine evaluates hundreds of variables beyond basic location and
            specialty, considering work environment preferences, cultural fit, schedule flexibility,
            and career goals to create highly accurate matches that benefit everyone involved.
          </p>
          <p>
            What makes us different is our commitment to being both disruptive and inclusive. We
            eliminate unnecessary middlemen and reduce costs through transparent terms and direct
            connections, yet we welcome traditional staffing agencies to leverage our technology and
            participate in the ecosystem. We provide comprehensive support through AI chatbots and
            dedicated customer success teams to ensure that every user, regardless of technical
            expertise, can confidently navigate the platform. From initial credential verification
            through scheduling, invoicing, and payment, we deliver a truly end-to-end solution that
            empowers healthcare organizations and providers to focus on what matters most:
            delivering exceptional patient care.
          </p>
        </div>
      </div>
    </div>
  );
};
